<template>
    <div class="users-main">
        <TFNavbar></TFNavbar>
        <div class="actions">
            <div class="box">
                <div class="actions-func">
                    <Input style="width:200px" v-model="conditions.name" :placeholder="$t('userName')" class="margin-r10 shadow112006"/>
                    <Button type="info" icon="md-search" @click="searchSubmit" class="shadow112006">{{$t('search')}}</Button>
                </div>
            </div>
        </div>
        <!-- table -->
        <Table border ref="selection" :columns="columns" :data="users" height="873"/>
        <!-- 底部分页 -->
        <TFFooter isShowPage :page="page" @change-page="changePage" @change-page-size="changePageSize"></TFFooter>
    </div>
</template>
<script>
import TFNavbar from './components/navbar.vue';
import TFFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';

export default {
    components: {
        TFNavbar,
        TFFooter
    },
    data() {
        // v-if="$store.state.user.rank==1"
        let columns = [
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('userName'));
                },
                key: 'name',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('userRank'));
                },
                align: 'center',
                render: (h, params) => {
                    var rank = params.row.rank == 1 ? this.$t('manageRank') : this.$t('normalRank');
                    return h('span', rank);
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('a_registerTime'));
                },
                key: 'created',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('updateTime'));
                },
                key: 'updated',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('action'));
                },
                key: 'action',
                width: 150,
                align: 'center',
                render: (h, params) => {
                    if (params.row.rank == 2) {
                        return h('div', [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: this.$t('a_deleteUser'),
                                                content: `${this.$t('a_sureDeleteUser')}：${params.row.name}？？？`,
                                                onOk: () => {
                                                    this.delUser(params.row.uid);
                                                }
                                            });
                                        }
                                    }
                                },
                                this.$t('delete')
                            )
                        ]);
                    } else {
                        return h('div', []);
                    }
                }
            }
        ];
        if (this.$store.state.user.rank != 1) {
            columns.pop();
        }
        return {
            conditions: {
                cid: this.$store.state.user.cid,
                page: 1,
                size: 20,
                name: ''
            },
            searchName: '',
            page: {
                page: 1, // 当前分页
                total: 0, // 总数
                size: 20
            }, // 分页
            users: [],
            // table columns
            columns
        };
    },
    created() {
        this.$store.commit('upNavbar', 8);
    },
    mounted() {
        // 查询试模文档数据
        this.getUsers();
    },
    methods: {
        // 获取客户
        getUsers() {
            // 查询客户数据
            Axios.get(AxiosUrl.user.list, {
                params: this.conditions
            }).then(res => {
                if (res.data.code == 200) {
                    this.page.page = res.data.data.page;
                    this.page.total = res.data.data.total;
                    let list = res.data.data.list;
                    list.forEach(item => {
                        item.created = Moment(item.created).format('YYYY-MM-DD HH:mm:ss');
                        item.updated = Moment(item.updated).format('YYYY-MM-DD HH:mm:ss');
                    });
                    this.users = list;
                }
            });
        },
        // 改变页数
        changePage(page) {
            this.conditions.page = page;
            this.getUsers();
        },
        // 改变每页数量
        changePageSize(size) {
            this.conditions.size = size;
            this.getUsers();
        },
        // 执行搜索
        searchSubmit() {
            this.getUsers();
        },
        //删除用户
        delUser(uid) {
            Axios.get(AxiosUrl.user.del, {
                params: {
                    uids: uid
                }
            }).then(res => {
                if (res.data.code) {
                    this.$Message.success(this.$t('deleteSuccess'));
                    this.getUsers();
                } else {
                    this.$Message.error(this.$t('a_deleteFail'));
                }
            });
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/views/users/users.vue